import { CanActivateChildFn, CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { APP_ROUTE_PATHS } from '../core/routing/app-route-paths';
import { SessionFacade } from '../core/state/session.store';

export const authRequiredMatchGuard: CanMatchFn = () => {
  const sessionFacade = inject(SessionFacade);
  const router = inject(Router);

  return sessionFacade.isAuthenticated()
    ? true
    : router.createUrlTree([`/${APP_ROUTE_PATHS.signIn}`]);
};

export const authRequiredChildGuard: CanActivateChildFn = () => {
  const sessionFacade = inject(SessionFacade);
  const router = inject(Router);

  return sessionFacade.isAuthenticated()
    ? true
    : router.createUrlTree([`/${APP_ROUTE_PATHS.signIn}`]);
};

export const signedOutOnlyMatchGuard: CanMatchFn = () => {
  const sessionFacade = inject(SessionFacade);
  const router = inject(Router);

  return sessionFacade.isAuthenticated()
    ? router.createUrlTree([`/${APP_ROUTE_PATHS.operator}`])
    : true;
};
